import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['fieldset']

  toggle(event) {
    this.fieldsetTargets.forEach(fieldset => {
      const active = fieldset.dataset.fieldsetToggleKey === event.target.value

      fieldset.disabled = !active
      fieldset.hidden = !active
    })
  }
}
